<i18n>
{
  "de": {
    "imprint": "Impressum",
    "noLegalInfo": "Keine rechtlichen Informationen bisher vorhanden"
  },
  "en": {
    "imprint": "Imprint",
    "noLegalInfo": "No legal information yet"
  }
}
</i18n>

<template>
  <section class="section mt-20">
    <div class="container">
      <div class="columns">
        <div
          class="column"
          :class="isMobileView ? 'is-hidden' : 'is-one-quarter'"
        >
          <sidenav />
        </div>
        <div class="column is-three-quarter">
          <div
            id="mainContent"
            class="box"
          >
            <h1 class="imprint-heading on-tile">
              {{ $t('imprint') }}
            </h1>
            <hr>
            <div
              v-if="hasImprint"
              class="content"
              v-html="artist.profile.configuration.legal.imprint"
            />
            <div v-else>
              {{ $t('noLegalInfo') }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState } from 'vuex'
import sidenav from '~/components/sidenav'

export default {
  components: { sidenav },

  data() {
    return {}
  },

  head() {
    return {
      title: this.artist.nickname
    }
  },

  computed: {
    ...mapState(['artist']),
    hasImprint() {
      return this.artist.profile.configuration &&
        this.artist.profile.configuration.legal &&
        this.artist.profile.configuration.legal.imprint
    }
  }
}
</script>
<style lang="scss">
@import 'assets/sass/_variables';

.unscrollable {
  overflow-y: hidden;
  max-height: 100vh;
}

.imprint-heading {
  color: $text !important;
}
</style>
